const isNumber = (val) => {
   return val !== undefined && val !== null && !Number.isNaN(+val);
};

// formatStringIntWithComma("123456") => "123,456"
const formatStringIntWithComma = (strInt) => {
   let retval = null;
   if (typeof strInt !== 'string') {
      console.error('Argument must be a string.');
   } else if (!isNumber(strInt)) {
      console.error('Argument must be a string integer parsable. The string must only contain digits and one decimal' +
         ' Place');
   } else {
      retval = strInt.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
   }
   return retval;
};

// formatStringFloat("123", 2) => "123.00"
// formatStringFloat("123.456", 2) => "123.45"
// formatStringFloat("123.456", 0) => "123"
// formatStringFloat("-123.456", 0) => "-123"
export const formatStringFloat = (strFloat, decimalPrecision = 0) => {
   let retval = '';

   if (typeof strFloat !== 'string') {
      console.error('Argument must be a string.');
   } else if (!isNumber(strFloat)) {
      console.error('Argument must be a string integer parsable. The string must only contain digits and one decimal' +
         ' Place');
   } else {
      const [wholeNumStr, deciNumStr] = `${ Number.parseFloat(strFloat) }`.split('.');

      retval = `${ formatStringIntWithComma(wholeNumStr) }`;
      if (decimalPrecision > 0) {
         let deciNumStrFormatter = deciNumStr || '';
         while (deciNumStrFormatter.length < decimalPrecision) {
            deciNumStrFormatter = `${ deciNumStrFormatter }0`;
         }

         deciNumStrFormatter = deciNumStrFormatter.slice(0, decimalPrecision);
         retval = `${ retval }.${ deciNumStrFormatter }`;
      }
   }

   return retval;
};
